{
  "devicesPage": {
    "item": {
      "empty": "Select device or group"
    }
  }
}